import { logRocketIdentity, logRocketWebOptions } from "@taskhealth/shared/logrocket-sanitize";
import LogRocket from "logrocket";

import type { LogRocketRedactProps } from "./logrocket";

const APP_ID = "s9yedh/mobile-web-app";

/**
 * The nurse PWA (mobile.taskshealth.com) records with the same web settings as
 * the agency portal and the Admin Hub: every text, input and image masked,
 * request and response bodies and query strings never sent, console not
 * recorded. No patient data reaches LogRocket (Nir, 2026-10-22). See
 * `@taskhealth/shared/logrocket-sanitize`.
 */
export function initLogRocket() {
    LogRocket.init(APP_ID, logRocketWebOptions());
}

/** Identifies the session by the nurse's rn id (and the role `rn`), nothing else. */
export function identifyLogRocket(userId: string) {
    const { uid, traits } = logRocketIdentity({ id: userId, role: "rn" });
    LogRocket.identify(uid, traits);
}

/**
 * Web counterpart of the native `logRocketRedactProps` (see `logrocket.ts`):
 * `data-private`, which the web recorder treats as "record the size of this
 * element and nothing else, children included". The image sanitizer alone is
 * not enough on this app: react-native-web draws an `Image` as a `<div>` with
 * the picture in its inline `background-image` style (a signed S3 link, or the
 * whole signature as a `data:` URL), and only the hidden `<img>` next to it is
 * masked.
 */
export function logRocketRedactProps(): LogRocketRedactProps {
    return { dataSet: { private: "true" } };
}
